<template>
<Box @close="close({})">
    <template #top>
        Registrar Pedido de Compra
    </template>
    <template #center>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-grid c3">
                    <InputSelect label="Almacen" v-model="pedido_items.alm_id" :source="almacenes" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacenes" :labelFunction="labelAlmacen"
                        @selectItem="buscarCentroCostoYLogisticos($event)">
                        <template #default="data">
                            {{ labelAlmacen(data.item) }}
                        </template>
                    </InputSelect>
                    <InputSelect label="Centros de costo" v-model="pedido_items.cec_id" :source="centros_costo" itemKey="cec_id" itemValue="cec_id" :filterFunction="filterCentroCosto"
                        :labelFunction="labelCentroCosto">
                        <template #default="data">
                            {{ labelCentroCosto(data.item) }}
                        </template>
                    </InputSelect>
                    <InputSelect label="Logistica" v-model="pedido_items.usu_logistica" :source="usuarios_logistica" itemKey="usu_id" itemValue="usu_id" :filterFunction="filterLogistica"
                        :labelFunction="labelLogistica">
                        <template #default="data">
                            {{ labelLogistica(data.item) }}
                        </template>
                    </InputSelect>
                </div>
                <div class="nj-grid c1">
                    <InputTextarea label="Notas" v-model="pedido_items.pei_notas"></InputTextarea>
                </div>
                <br>
                <SearchBox label="Productos" itemKey="prv_id" itemValue="prv_id" :source="productos" :searchFunction="buscarProductos" @selectItem="agregarProducto">
                    <template #default="data">
                        {{ labelProducto(data.item) }}
                    </template>
                </SearchBox>
                <br>
                <b-table :data="pedido_items.lista_pedido_items_detalle" style="width: 100%;">
                    <template slot-scope="props">
                        <b-table-column label="ID" header-class="is-info" style="width: 80px;">{{ props.row.prv_id }}</b-table-column>
                        <b-table-column label="Producto" header-class="is-info">{{ props.row.pid_producto }}</b-table-column>
                        <b-table-column label="Cant. solicitada" header-class="is-info" style="width: 120px">
                            <input type="text" class="nj-text right" v-model="props.row.pid_cantidad_solicitada" />
                        </b-table-column>
                        <b-table-column label="Opciones" header-class="is-info" style="width: 80px;">
                            <div class="nj-flex justify-center">
                                <Button type="icon" color="red" icon="delete" title="Remover" @click="remover(props.row)"></Button>
                            </div>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </template>
    <template #bottom>
        <Button icon="save" color="green" label="Registrar" @click="registrar()"></Button>
    </template>
</Box>
</template>
<script>
import { EstadoEnum, RolesEnum } from "../../constants"
import { EmpleadoService, PedidoItemsService, ProductoService, ResponseStatus, UsuarioService } from "../../services"
import OpcionesService from "../../services/OpcionesService"
import Toast from "../../util/toast"
import { Box, Button, InputSelect, InputText, InputTextarea, SearchBox } from "../components/"
export default {
    name: "RegistrarPedidoItems",
    components: {
        Box,
        InputText,
        InputTextarea,
        InputSelect,
        Button,
        SearchBox,
    },
    data() {
        return {
            pedido_items: {
                est_codigo: null,
                alm_id: null,
                pei_notas: null,
                usu_solicitante: null,
                usu_logistica: null,
                lista_pedido_items_detalle: []
            },
            productos: [],
            almacenes: [],
            centros_costo: [],
            usuarios_logistica: [],
        }
    },
    methods: {
        close({
            interfaz = "",
            buscar = false
        }) {
            this.$emit("close", {
                interfaz,
                buscar,
            })
        },
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        filterAlmacenes(items, param) {
            if (param != null) {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelCentroCosto(item) {
            return `${item.cec_codigo} - ${item.cec_descripcion}`
        },
        filterCentroCosto(items, param) {
            if (param != null) {
                return items.filter(item => `${item.cec_codigo} - ${item.cec_descripcion}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelProducto(item) {
            return item.prv_nombre
        },
        buscarCentroCostoYLogisticos(almacen) {
            if (almacen) {
                // obteniendo los centros de costos
                OpcionesService
                    .getCentrosCosto({
                        est_codigo: EstadoEnum.ACTIVO.est_id,
                        pry_id: UsuarioService.getUsuario().usu_nivel != 1
                            ? almacen.pry_id
                            : null
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.centros_costo = response.data
                            UsuarioService
                                .buscar({
                                    usuario: {
                                        rol_id: RolesEnum.LOGISTICA.rol_id
                                    }
                                })
                                .then(response => {
                                    if (ResponseStatus.isSuccess(response)) {
                                        this.usuarios_logistica = response.data
                                    }
                                    else {
                                        Toast.error(response.message)
                                    }
                                })
                                .catch(error => {
                                    Toast.error(error)
                                })
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
            else {
                this.centros_costo = []
                this.usuarios_logistica = []
            }
        },
        filterLogistica(items, param) {
            if (param != null) {
                return items.filter(item => item.emp_nombre_completo.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelLogistica(item) {
            return item.usu_nombre || ' ' || usu_apellido
        },
        filterSolicitante(items, param) {
            if (param != null) {
                return items.filter(item => (item.usu_nombre || ' ' || usu_apellido).toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelSolicitante(item) {
            return item.emp_nombre_completo
        },
        buscarProductos(prv_nombre) {
            ProductoService
                .buscarRapido({
                    producto: {
                        prv_nombre
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.productos = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        agregarProducto(producto) {
            if (producto != null) {
                this.pedido_items.lista_pedido_items_detalle.push({
                    prv_id: producto.prv_id,
                    pid_producto: producto.prv_nombre
                })
            }
        },
        remover(producto) {
            this.pedido_items.lista_pedido_items_detalle = this.pedido_items.lista_pedido_items_detalle
                .filter(item => item.prv_id != producto.prv_id)
        },
        registrar() {
            PedidoItemsService
                .registrar({
                    pedido_items: this.pedido_items
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.close({
                            buscar: true
                        })
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
    },
    mounted() {
        // obteniendo al solicitante
        this.pedido_items.usu_solicitante = UsuarioService.getUsuario().usu_id
        // obteniendo los almacenes
        OpcionesService
            .getOpciones({
                almacen: {
                    pry_id: UsuarioService.getUsuario().usu_nivel != 1
                        ? UsuarioService.getUsuario().pry_id
                        : null
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.almacenes = response.data.almacenes
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped></style>